import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Card,
  CardContent,
  Tooltip,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import axios from "axios";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { giftCardApi } from "../../app/slices/giftCardSlice";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axiosInstance from "../../utils/axiosInstance";
const IndividualGiftCard = () => {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(giftCardApi());
  }, [dispatch]);

  const sliceResponse = useSelector((state) => state.giftCard.giftCard.data);
  const stateLoading = useSelector((state) => state.giftCard.loading);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [formData, setFormData] = useState({
    amount: "",
    email: "",
    phone: "",
    metal_type: "",
    refinery: "Augmont",
  });
  // console.log("formData: ", formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const { amount, email, phone, metal_type, refinery } = formData;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!metal_type) {
      Swal.fire({
        text: "Metal Type are required",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    if (!refinery) {
      Swal.fire({
        text: "Refinery are required",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    if (!emailRegex.test(email)) {
      Swal.fire({
        text: "Please enter a valid email address",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    if (!phoneRegex.test(phone)) {
      Swal.fire({
        text: "Phone must be a 10-digit number",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }
    if (!amount) {
      Swal.fire({
        text: "Amount is required",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }
    if (amount <= 0) {
      Swal.fire({
        text: "Amount should be positive",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }
    if (amount >= 101) {
      Swal.fire({
        text: "Amount should be less than 101",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setSubmitLoading(true);
    try {
      const response = await axiosInstance.post(
        `/giftcardcreate`,
        formData,
        // { headers }
      );
      // const response = await axios.post(
      //     `${baseUrl}/giftcardcreate`,
      //     formData,
      //     { headers }
      // );

      if (response.data.error === false) {
        // setFormData({ amount: "", email: "", phone: "", metal_type: "", });
        setFormData((prev) => ({
          ...prev,
          amount: "",
          email: "",
          phone: "",
          metal_type: "",
        }));

        dispatch(giftCardApi());

        Swal.fire({
          text: response.data?.message || "Form submitted successfully",
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          text: response.data?.message || "Something went wrong!",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      Swal.fire({
        text: "Something went wrong",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("giftcode", {
      header: "Gift Code",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.giftcode);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.giftcode}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.giftcode}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("allocationId", {
      header: "Partner Allocation Id",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.allocationId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.allocationId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.allocationId || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("EmpAllocationId", {
      header: "Employee Allocation Id",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.EmpAllocationId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.EmpAllocationId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.EmpAllocationId || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("transactionId", {
      header: "Transaction Id",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionId || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("name", {
      header: "Name",
    }),
    columnHelper.accessor("phone", {
      header: "Phone",
    }),
    columnHelper.accessor("email", {
      header: "Email",
    }),
    columnHelper.accessor("amount", {
      header: "Amount",
    }),
    columnHelper.accessor("metal_type", {
      header: "Metal Type",
    }),
    columnHelper.accessor("refinery", {
      header: "Refinery",
    }),
    columnHelper.accessor("redeemed", {
      header: "Redeemed",
      Cell: (cell) =>
        cell.row.original.redeemed ? (
          <span style={{ color: "green" }}>yes</span>
        ) : (
          <span style={{ color: "red" }}>No</span>
        ),
    }),
    columnHelper.accessor("status", {
      header: "status",
      Cell: (cell) => cell.row.original.status,
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),
    columnHelper.accessor("expiresin", {
      header: "Expires In",
      Cell: (cell) => cell.row.original.expiresin,
    }),

    columnHelper.display({
      id: "actions",
      header: "Actions",
      Cell: ({ row }) => {
        const isRedeemed = row.original.redeemed;
        const isExpired = row.original.status == "Expired";

        return (
          <Box>
            <>
              <Tooltip title={isRedeemed || isExpired ? "Cannot Edit" : "Edit"}>
                <span>
                  <IconButton
                    onClick={() =>
                      !isRedeemed || (!isExpired && handleEdit(row.original))
                    }
                    sx={{
                      color: isRedeemed || isExpired ? "brown" : "primary.main",
                      pointerEvents: isRedeemed || isExpired ? "none" : "auto",
                      opacity: isRedeemed || isExpired ? 0.5 : 1,
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip
                title={isRedeemed || isExpired ? "Cannot Delete" : "Delete"}
              >
                <span>
                  <IconButton
                    onClick={() =>
                      !isRedeemed && handleDelete(row.original._id)
                    }
                    sx={{
                      color: isRedeemed || isExpired ? "brown" : "error.main",
                      pointerEvents: isRedeemed || isExpired ? "none" : "auto",
                      opacity: isRedeemed || isExpired ? 0.5 : 1,
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </>
          </Box>
        );
      },

      // Cell: ({ row }) => {
      //     const isRedeemed = row.original.redeemed;

      //     return (
      //         <Box>
      //             <>
      //                 <Tooltip title={isRedeemed ? "Cannot Edit" : "Edit"}>
      //                     <span>
      //                         <IconButton
      //                             disabled={isRedeemed}
      //                             onClick={() => handleEdit(row.original)}
      //                         >
      //                             <EditIcon color="primary" />
      //                         </IconButton>
      //                     </span>
      //                 </Tooltip>

      //                 <Tooltip title={isRedeemed ? "Cannot Delete" : "Delete"}>
      //                     <span>
      //                         <IconButton
      //                             disabled={isRedeemed}
      //                             onClick={() => handleDelete(row.original._id)}
      //                         >
      //                             <DeleteIcon style={{ color: isRedeemed ? "brown" : "red !important" }} />
      //                         </IconButton>
      //                     </span>
      //                 </Tooltip>
      //             </>
      //         </Box>
      //     );
      // },

      // Cell: ({ row }) => {
      //     let isRedeemed = row.original.redeemed;
      //     return (<Box>
      //         <>
      //             <Tooltip title={isRedeemed?"Cannot Edit":"Edit"}>
      //                 <IconButton disabled={isRedeemed} onClick={() => handleEdit(row.original)}>
      //                     <EditIcon color="primary" />
      //                 </IconButton>
      //             </Tooltip>
      //             <Tooltip title="Delete">
      //                 <IconButton onClick={() => handleDelete(row.original._id)}>
      //                     <DeleteIcon color="error" />
      //                 </IconButton>
      //             </Tooltip>
      //         </>

      //     </Box >)
      // },
    }),
  ];

  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const handleEdit = (rowData) => {
    setIsEditMode(true);
    setEditId(rowData._id);
    setFormData({
      amount: rowData.amount,
      email: rowData.email,
      phone: rowData.phone,
      metal_type: rowData.metal_type,
      refinery: rowData.refinery,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;

    setSubmitLoading(true);
    try {
      const response = await axiosInstance.post(
        `/giftcardupdate/${editId}`, // replace with your actual endpoint
        formData,
        // { headers }
      );
      // const response = await axios.post(
      //     `${baseUrl}/giftcardupdate/${editId}`, // replace with your actual endpoint
      //     formData,
      //     { headers }
      // );

      if (response.data.error === false) {
        toast.success(response.data?.message || "Updated successfully");
        // setFormData({ amount: "", email: "", phone: "", metal_type: "", });
        setFormData((prev) => ({
          ...prev,
          amount: "",
          email: "",
          phone: "",
          metal_type: "",
        }));

        setIsEditMode(false);
        setEditId(null);
        dispatch(giftCardApi());
      } else {
        toast.error(response.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Update error", err);
      toast.error("Something went wrong");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this gift card?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await axiosInstance.post(
          `/giftcarddelete/${id}`,
          {},
          //      {
          //     headers,
          // }
        );
        // const response = await axios.post(`${baseUrl}/giftcarddelete/${id}`, {}, {
        //     headers,
        // });

        if (response.data.error === false) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Gift card has been deleted.",
            timer: 2000,
            showConfirmButton: false,
          });
          dispatch(giftCardApi());
          // setFormData({ amount: "", email: "", phone: "", metal_type: "", });
          setFormData((prev) => ({
            ...prev,
            amount: "",
            email: "",
            phone: "",
            metal_type: "",
          }));

          setIsEditMode(false);
          setEditId(null);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed!",
            text: response.data?.message || "Delete failed",
          });
        }
      } catch (error) {
        console.error("Delete error", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    }
  };

  return (
    <>
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Box component="form" onSubmit={(e) => e.preventDefault()}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Metal Type</InputLabel>
                  <Select
                    fullWidth
                    label="Metal Type"
                    name="metal_type"
                    value={formData.metal_type}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value={"gold"}>Gold</MenuItem>
                    <MenuItem value={"silver"}>Silver</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Refinery</InputLabel>
                  <Select
                    fullWidth
                    label="Refinery"
                    name="refinery"
                    // value={formData.refinery}
                    value={formData.refinery || "Augmont"}
                    onChange={handleChange}
                    required
                    disabled
                  >
                    {/* <MenuItem value={"MMTC-PAMP"} >MMTC-PAMP</MenuItem> */}
                    <MenuItem value={"Augmont"}>Augmont</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="email"
                  label="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="tel"
                  label="Phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  inputProps={{ maxLength: 10 }}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="number"
                  label="amount"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                />
              </Grid>

              {isEditMode && (
                <Grid item xs={12} sm={3}>
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: "#bc2020 !important", // red color
                      p: { xs: 1, sm: 1.8, md: 1.8 },
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "100%",
                        lg: "100%",
                        xl: "100%",
                      },
                      transition: "transform 0.5s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.01)", // Increase size on hover
                      },
                    }}
                    onClick={() => {
                      setIsEditMode(false);
                      setEditId(null);
                      // setFormData({ amount: "", email: "", phone: "", metal_type: "", });
                      setFormData((prev) => ({
                        ...prev,
                        amount: "",
                        email: "",
                        phone: "",
                        metal_type: "",
                      }));
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              )}

              <Grid item xs={12} sm={isEditMode ? 3 : 6}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  disabled={submitLoading}
                  // onClick={handleSubmit}
                  onClick={isEditMode ? handleUpdate : handleSubmit}
                  sx={{
                    p: { xs: 1, sm: 1.8, md: 1.8 },
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "100%",
                      lg: "100%",
                      xl: "100%",
                    },
                    transition: "transform 0.5s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.01)", // Increase size on hover
                    },
                  }}
                >
                  {submitLoading ? "Submitting..." : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="GiftCard"
      />
    </>
  );
};

export default IndividualGiftCard;
